// src/components/markdown-renderer/components/TableRenderer.tsx
import React from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import styles from '~/styles/MarkdownRenderer.module.css'
import type { TableData } from '../types'

export const TableRenderer: React.FC<TableData> = ({ headers, rows }) => {
  return (
    <div className={styles['table-container']}>
      <Table className={styles['table-main']}>
        <TableHeader>
          <TableRow className={styles['table-header-row']}>
            {headers.map((header, i) => (
              <TableHead
                key={i}
                className={styles['table-header-cell']}
              >
                {header}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.map((row, i) => (
            <TableRow
              key={i}
              className={styles['table-body-row']}
            >
              {row.map((cell, j) => (
                <TableCell
                  key={j}
                  className={styles['table-body-cell']}
                >
                  {cell}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}
